import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import jwtDecode from 'jwt-decode';
import { getAccessToken, setAccessToken } from './utils';
import { OV_ID_URL } from '../../config/theme';
export var isTokenExpired = function isTokenExpired(token) {
  if (!token) {
    return true;
  }

  try {
    var _jwtDecode = jwtDecode(token),
        exp = _jwtDecode.exp;

    var now = Date.now();
    return now >= exp * 1000;
  } catch (_unused) {
    return true;
  }
};
export var errorResponse = {
  data: {
    error: 'Could not fetch.'
  }
}; // A client to communicate with the OV ID graphql API.

var OVIDClient = /*#__PURE__*/_createClass(function OVIDClient() {
  var _this = this;

  _classCallCheck(this, OVIDClient);

  _defineProperty(this, "headers", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var token, request, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = getAccessToken();

            if (token) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              'Content-Type': 'application/json'
            });

          case 3:
            if (!isTokenExpired(token)) {
              _context.next = 18;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(OV_ID_URL, "auth/refresh-token"), {
              credentials: 'include',
              method: 'POST'
            });

          case 7:
            request = _context.sent;
            _context.next = 10;
            return request.json();

          case 10:
            response = _context.sent;
            token = response.accessToken;
            setAccessToken(token);
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](4);
            console.error(_context.t0);

          case 18:
            return _context.abrupt("return", {
              authorization: "bearer ".concat(token),
              'Content-Type': 'application/json'
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 15]]);
  })));

  _defineProperty(this, "query", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
      var variables,
          headers,
          request,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              variables = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              _context2.next = 3;
              return _this.headers();

            case 3:
              headers = _context2.sent;
              _context2.prev = 4;
              _context2.next = 7;
              return fetch("".concat(OV_ID_URL, "graphql"), {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                  query: query,
                  variables: variables
                })
              });

            case 7:
              request = _context2.sent;
              return _context2.abrupt("return", request.json());

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              console.error(_context2.t0);
              return _context2.abrupt("return", errorResponse);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 11]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());

  _defineProperty(this, "mutate", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query) {
      var variables,
          headers,
          request,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              variables = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
              _context3.next = 3;
              return _this.headers();

            case 3:
              headers = _context3.sent;
              _context3.prev = 4;
              _context3.next = 7;
              return fetch("".concat(OV_ID_URL, "graphql"), {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                  query: query,
                  variables: variables
                })
              });

            case 7:
              request = _context3.sent;
              return _context3.abrupt("return", request.json());

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              console.error(_context3.t0);
              return _context3.abrupt("return", errorResponse);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 11]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }());
});

export default OVIDClient;